import{createContext as r}from"react";var o=r(void 0);export{o as focusScope};
//# sourceMappingURL=scope.js.map
